import React from 'react';
import { Modal } from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export const NoPdfFileModal = ({ setShowModal, isOpen, onSuccess }) => {
  const { t } = useTranslation();
  return (
    <Modal
      showModal={isOpen}
      setShowModal={setShowModal}
      onSuccess={onSuccess}
      showCancel
      cancelText={t(translations.COMMON.BACK)}
      persist
      width="md:w-6/12 xl:w-4/12"
      title={t(translations.MODALS.PDF_CONVERT_TITLE)}>
      <>
        <p className="max-w-[500px] text-center text-paragraph md:text-subtitle">
          {t(translations.MODALS.PDF_CONVERT_MESSAGE)}
        </p>
        <p className="mt-10 max-w-[500px] text-center text-paragraph md:text-subtitle">
          {t(translations.COMMON.WANT_TO_CONTINUE)}
        </p>
      </>
    </Modal>
  );
};
